import { render } from "./TopblockEmpty.vue?vue&type=template&id=91f31342"
import script from "./TopblockEmpty.vue?vue&type=script&lang=js"
export * from "./TopblockEmpty.vue?vue&type=script&lang=js"

import "./TopblockEmpty.vue?vue&type=style&index=0&id=91f31342&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__